export interface Testimonial {
  name: string;
  title: string;
  quote: string;
  avatar: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "Trish Keiller",
    title: "Wholistic Education Coach",
    quote: "Devcubix has a team of exceptional workers who are highly accessible, communicate effectively, and strive for excellence. They empower clients to take on tasks beyond scope, resulting in more efficient collaboration. I highly recommend Devcubix.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face",
  },
  {
    name: "David Mohamed",
    title: "Client, US",
    quote: "Devcubix went above and beyond. Very easy to work with, available 24/7, works quickly. I'm picky and he did everything I asked and more. Highly recommended.",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face",
  },
  {
    name: "Hanah Kim",
    title: "Realtor at Zillow",
    quote: "Devcubix is very responsible and does great work. Flexible and kind. I appreciate his hard work and patience. I recommend him to anyone needing website work. Will work with him again.",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face",
  },
  {
    name: "Michael Kroll",
    title: "Financial Advisor",
    quote: "Devcubix did fantastic work on my website. Very responsive, quick with changes, efficient, met exact timeframe. Would hire again without question.",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face",
  },
  {
    name: "Goran Karanovic",
    title: "Business Leader",
    quote: "Devcubix is a world class gem among freelancers. Easy to talk to, quick to understand assignments. Very happy with WordPress website. Will hire again.",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop&crop=face",
  },
  {
    name: "Don Hubert",
    title: "Resources for Development Consulting",
    quote: "Devcubix literally received brief and got to work immediately to meet tight deadline. Responsive, approachable, easy to communicate with, extremely professional. Would recommend.",
    avatar: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=80&h=80&fit=crop&crop=face",
  },
  {
    name: "Linda Robert",
    title: "Life Coach",
    quote: "Devcubix redesigned my website excellently. Responsive to requests, quick completion. Created tutorial videos for site changes. Love new website. Highly recommend.",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=face",
  },
  {
    name: "Matthew Baltzel",
    title: "Client",
    quote: "Bilal and Devcubix does amazing job, honored to have as part of team. Work is top-notch, always quick with communication. Go-to for IT work.",
    avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=80&h=80&fit=crop&crop=face",
  },
];
